module.exports = __webpack_public_path__ + "static/media/1916832_1258099779331_3649496_n.e524899a.jpg";